module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "header",
    class: {
      mouseDisabled: _vm.mouseStatus
    }
  }, [_c('el-row', {
    class: {
      aeIsNormal: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    class: {
      floatRightStyle: _vm.$i18n.locale === 'ae'
    },
    staticStyle: {
      "font-size": "0"
    },
    attrs: {
      "span": 3
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "5px",
      "width": "50%",
      "margin-top": "-5px",
      "margin-left": "-5px",
      "margin": "auto"
    },
    attrs: {
      "src": require("../assets/img/login/Logo.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "head-menu",
    class: {
      floatRightStyle: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "background-color": "#000",
      "text-color": "#fff",
      "active-text-color": "#00AFFF"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, _vm._l((_vm.navData), function(item, index) {
    return (item.status) ? _c('li', {
      key: index
    }, [(item.children) ? _c('el-submenu', {
      attrs: {
        "index": item.index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      class: item.class,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _vm._l((item.children), function(val, j) {
      return (val.status) ? _c('el-menu-item', {
        key: j,
        attrs: {
          "index": val.index
        },
        on: {
          "click": function($event) {
            return _vm.jump(val.index, val.path)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(val.label) + "\n                            ")]) : _vm._e()
    })], 2) : _c('el-menu-item', {
      attrs: {
        "index": item.index
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.index, item.path)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.class,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(item.label))])])], 2)], 1) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "head-operation",
    attrs: {
      "span": 7
    }
  }, [_c('span', {
    staticClass: "el-icon-my-meijin",
    staticStyle: {
      "color": "#00AFFF",
      "vertical-align": "middle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "balance-style",
    class: {
      smallSize: _vm.isSmall
    }
  }, [_vm._v(_vm._s(_vm.user_balance))]), _vm._v(" "), _c('span', {
    staticClass: "language"
  }, [_vm._l((_vm.langOptions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "lang_img"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.countryVal == item.value),
        expression: "countryVal == item.value"
      }],
      attrs: {
        "src": require(("@/assets/img/country/" + (item.img))),
        "height": "18"
      }
    })])
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "prefix": "el-icon-search",
      "popper-class": "downStyle"
    },
    on: {
      "change": _vm.changeLanguage
    },
    model: {
      value: (_vm.countryVal),
      callback: function($$v) {
        _vm.countryVal = $$v
      },
      expression: "countryVal"
    }
  }, _vm._l((_vm.langOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left",
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle",
        "height": "16px"
      },
      attrs: {
        "src": require(("@/assets/img/country/" + (item.img)))
      }
    })])])
  }), 1)], 2), _vm._v(" "), _c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "width": "30",
      "src": require("../assets/img/user.png")
    }
  }), _vm._v("\n                         " + _vm._s(_vm.login_username) + "\n                        "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "set-icon",
    class: {
      setIconAe: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.showSystemMsg) ? _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.viewMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-bell",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.systemMsg')))])])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.toLink
    }
  }, [_c('i', {
    staticClass: "fa fa-random",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.link')))])])]), _vm._v(" "), _c('el-dropdown-item', [(_vm.showWithdraw) ? _c('div', {
    on: {
      "click": _vm.toMoney
    }
  }, [_c('div', {
    staticStyle: {
      "width": "14px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "el-icon-my-chujinn"
  })]), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.withDraw')))])]) : _vm._e()]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.toTransfer
    }
  }, [_c('div', {
    staticStyle: {
      "width": "14px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "el-icon-my-zhuanzhang"
  })]), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.transferApply')))])])]), _vm._v(" "), _c('el-dropdown-item', [(_vm.showEditMsg) ? _c('div', {
    staticClass: "edPwd",
    on: {
      "click": _vm.editPassword
    }
  }, [_c('span', {
    staticClass: "el-icon-my-addmsg"
  }), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.editPwd')))])]) : _vm._e()]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('div', {
    staticClass: "home-logout",
    on: {
      "click": _vm.loginOut
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "drop-margin"
  }, [_vm._v(_vm._s(_vm.$t('home.logout')))])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "routerView"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center!important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('other.other_footer', {
        val: _vm.thisYear
      }))
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('home.editPwd'),
      "visible": _vm.pwdVisible,
      "width": "30%",
      "before-close": _vm.pwdClose
    },
    on: {
      "update:visible": function($event) {
        _vm.pwdVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "pwdDialog"
  }, [_c('el-form', {
    ref: "pwdForm",
    attrs: {
      "model": _vm.pwdForm,
      "rules": _vm.pwdRules,
      "label-width": _vm.$i18n.locale == 'en' ? '150px' : '80px'
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.oldPwd'),
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.pwdForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "oldPwd", $$v)
      },
      expression: "pwdForm.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.password'),
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.pwdForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newPwd", $$v)
      },
      expression: "pwdForm.newPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.confirmPass'),
      "prop": "checkNewPwd"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.pwdForm.checkNewPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "checkNewPwd", $$v)
      },
      expression: "pwdForm.checkNewPwd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.pwdClose
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editPwdSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('home.link'),
      "visible": _vm.linkVisible,
      "width": "40%",
      "before-close": _vm.linkClose,
      "custom-class": "linkDialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.linkVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.linkLoading),
      expression: "linkLoading"
    }],
    staticClass: "link-card"
  }, _vm._l((_vm.linkData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "margin-bottom": "10px",
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "linkTitle"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('div', {
      staticClass: "linkDesc"
    }, [_c('a', {
      attrs: {
        "href": item,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item))])])])
  }), 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('home.systemMsg'),
      "visible": _vm.messageVisible,
      "width": "80%",
      "before-close": _vm.messageClose,
      "custom-class": "messageDialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.messageVisible = $event
      }
    }
  }, [(_vm.messageData.length == 0) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.msgLoading),
      expression: "msgLoading"
    }],
    staticClass: "messageContent"
  }, [(_vm.showAddMsg) ? _c('div', {
    staticClass: "msgSend"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMsg
    }
  }, [_vm._v(_vm._s(_vm.$t('home.addMsg')) + " "), _c('span', {
    staticClass: "el-icon-my-addmsg"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "messageDesc",
    staticClass: "messageDesc",
    class: {
      showMsgBtn: !_vm.showAddMsg
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('home.noData')) + "\n            ")])]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.msgLoading),
      expression: "msgLoading"
    }],
    staticClass: "messageContent"
  }, [(_vm.showAddMsg) ? _c('div', {
    staticClass: "msgSend"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMsg
    }
  }, [_vm._v(_vm._s(_vm.$t('home.addMsg')) + " "), _c('span', {
    staticClass: "el-icon-my-addmsg"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "messageDesc",
    staticClass: "messageDesc",
    class: {
      showMsgBtn: !_vm.showAddMsg
    }
  }, _vm._l((_vm.messageData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "msgCard"
    }, [(_vm.showDelMsg) ? _c('span', {
      staticClass: "msgDel",
      on: {
        "click": function($event) {
          return _vm.delMsg(item.message_id)
        }
      }
    }, [_c('span', {
      staticClass: "el-icon-my-delete"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "linkTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "linkDesc",
      class: {
        contentColor: item.read_status == '0' ? false : true
      },
      on: {
        "click": function($event) {
          return _vm.isReadNow(item)
        }
      }
    }, [_vm._v(_vm._s(item.content))])])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "messagePage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('home.addMsg'),
      "visible": _vm.addMsgVisible,
      "width": "40%",
      "before-close": _vm.addMsgClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addMsgVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addMsgForm",
    attrs: {
      "model": _vm.addMsgForm,
      "rules": _vm.addMsgRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.title'),
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterMsgTitle')
    },
    model: {
      value: (_vm.addMsgForm.title),
      callback: function($$v) {
        _vm.$set(_vm.addMsgForm, "title", $$v)
      },
      expression: "addMsgForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.content'),
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 5
      },
      "resize": "none",
      "placeholder": _vm.$t('placeholder.enterMsgContent')
    },
    model: {
      value: (_vm.addMsgForm.content),
      callback: function($$v) {
        _vm.$set(_vm.addMsgForm, "content", $$v)
      },
      expression: "addMsgForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.addMsgClose
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addMsgLoading
    },
    on: {
      "click": _vm.addMsgSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bdc654e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 1178
// module chunks = 1